var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "max-w-5xl mx-auto mt-5" }, [
    _c(
      "div",
      {},
      [
        _c("div", { staticClass: "bg-white shadow sm:rounded-lg" }, [
          _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
            _c(
              "h3",
              {
                staticClass: "text-lg leading-6 font-medium text-gray-900",
                attrs: { id: "renew-headline" }
              },
              [_vm._v(" Whatsapp Chat ")]
            ),
            _c(
              "div",
              { staticClass: "mt-2 sm:flex sm:items-start sm:justify-between" },
              [
                _vm._m(0),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
                  },
                  [
                    _c("VSwitch", {
                      attrs: { value: _vm.config.isEnabled },
                      on: { input: _vm.handleSwitch }
                    })
                  ],
                  1
                )
              ]
            )
          ])
        ]),
        _vm.config.isEnabled
          ? _c("ChatConfigureForm", {
              attrs: { config: _vm.config },
              on: { save: _vm.updateConfig }
            })
          : _vm._e(),
        _vm.config.isEnabled
          ? _c(
              "div",
              [
                _vm.config.isEnabled
                  ? _c("OfficeHours", {
                      attrs: { config: _vm.config },
                      on: { save: _vm.updateConfig }
                    })
                  : _vm._e(),
                _vm.config.isEnabled
                  ? _c("CalloutCard", {
                      attrs: { config: _vm.config },
                      on: { save: _vm.updateConfig }
                    })
                  : _vm._e(),
                _vm.config.isEnabled
                  ? _c("ChatWidget", {
                      attrs: { config: _vm.config },
                      on: { save: _vm.updateConfig }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _c("Notification", {
          attrs: { text: _vm.notificationText, show: _vm.showNotification }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "max-w-xl text-sm leading-5 text-gray-500" },
      [
        _c("p", { attrs: { id: "renew-description" } }, [
          _vm._v(" Enable or Disable WhatsApp chat on your store ")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }